/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";

import { IoInformationCircle } from "react-icons/io5";

import { formatDuration } from "../../helpers";
import ClickableTooltip from "../common/ClickableTooltip";

const PriorityBadge = ({ priority }) => {
  const classes = [
    "priority-badge",
    "is-small",
    `is-${priority.toLowerCase()}`
  ];
  return <div className={classes.join(" ")} />;
};
PriorityBadge.propTypes = {
  priority: PropTypes.string
};
PriorityBadge.defaultProps = {
  priority: "Low"
};

export const SUPPORT_TICKET_COLUMNS = [
  {
    Header: "Priority",
    accessor: "request_priority",
    maxWidth: 60,
    Cell: (cell) => <PriorityBadge priority={cell.value} />
  },
  {
    id: "request_status",
    Header: "Ticket #",
    accessor: "support_ticket_number",
    maxWidth: 73
  },
  {
    id: "request_number",
    Header: "Status",
    accessor: "request_status.label",
    maxWidth: 100
  },
  {
    id: "requestor_company_name",
    Header: "Customer",
    accessor: "requestor_company_name"
  },
  {
    Header: "Nature",
    accessor: "request_nature_details",
    id: "request_nature_details",
    maxWidth: 65,
    Cell: (cell) => (
      <ClickableTooltip
        custom
        id={cell.original._id}
        place="bottom"
        tooltipContent={
          <React.Fragment>
            <b>{cell.original.requestor_full_name}: </b>
            {cell.value}
          </React.Fragment>
        }
      >
        <IoInformationCircle style={{ color: "#50accb" }} />
      </ClickableTooltip>
    )
  },
  {
    id: "age",
    Header: "Age",
    accessor: "age",
    Cell: ({ value }) => formatDuration(value, ["day", "hour", "minute"])
  }
];

export const SUPPORT_TICKET_COLUMNS_MOBILE = [
  {
    Header: "Priority",
    accessor: "request_priority",
    maxWidth: 80,
    Cell: (cell) => <PriorityBadge priority={cell.value} />
  },
  {
    id: "requestor_company_name",
    Header: "Customer",
    accessor: "requestor_company_name"
  }
];
